// The horizontal proxy scrollbar: the table's one horizontal scrollbar at 768px and wider, rendered only
// while the table overflows its region. It sits in flow below the region and sticks to the bottom of the
// scroll container, so it pins to the viewport bottom while the table extends below it and parks under the
// table once the table's bottom edge is in view. Its spacer is as wide as the table, so its scrollLeft is the
// table's; useGeometry listens to it. Keyboard and assistive technology reach the columns by focus, which
// scrolls them into view, so the bar itself stays out of the tab order and the accessibility tree.

import React from 'react'

import { useTable } from '../context'

export const ProxyScrollbar = () => {
  const { geometry } = useTable()
  if (!geometry || !geometry.locking) return null
  return (
    <div
      ref={geometry.proxyRef}
      className="me-table-proxy"
      data-hidden={geometry.proxyShown ? undefined : ''}
      aria-hidden="true"
      tabIndex={-1}
    >
      <div
        className="me-table-proxy-spacer"
        style={{ width: `${geometry.scrollWidth}px` }}
      />
    </div>
  )
}
